import BaseService from "@/boot/BaseService";
class PrecioListaService extends BaseService {
  constructor() {
    super(null, "/config");
  }
  async getParametros() {
    return await this.get("/parametros");
  }

  async getVariable(variable) {
    return await this.get("/variable", { variable });
  }

  async setVariable(variable, valor) {
    return await this.post("/variable", { variable, valor });
  }

  async getPerfileria() {
    return await this.getVariable('MV_ZPERF');
  }
  async getSelladores() {
    return await this.getVariable('MV_ZSELL');
  }
}

export default new PrecioListaService();
